import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";
const formField = {
  lineNo: {
    type: "number",
    name: "lineNo",
    label: "PO Line No",
    errorMsg: "PO Line No is required.",
    required: true,
    disabled: true,
  },
  extPONumber: {
    type: "text",
    name: "extPONumber",
    label: "Ext PO Number",
    errorMsg: "Ext PO Number is required.",
    maxLength: 20,
    //required: true,
    disabled: true,
  },
  extPOLineNo: {
    type: "text",
    name: "extPOLineNo",
    label: "Ext PO Line No",
    maxLength: 20,
    disabled: true,
  },
  skuCode: {
    type: "select",
    name: "skuCode",
    label: "SKU Code",
    errorMsg: "SKU Code is required.",
    maxLength: 50,
    required: true,
    editable: false,
  },
  parentSKUCode: {
    type: "text",
    name: "parentSKUCode",
    label: "Parent SKU",
    maxLength: 50,
  },
  skuDescription: {
    type: "text",
    name: "skuDescription",
    label: "SKU Description",
    maxLength: 100,
  },
  packType: {
    type: "text",
    name: "packType",
    label: "Pack Type",
    maxLength: 10,
    disabled: true,
  },
  poQty: {
    type: "number",
    name: "poQty",
    label: "PO Qty",
    required: true,
  },
  qtyOrdered: {
    type: "number",
    name: "qtyOrdered",
    label: "Quantity Ordered",
    errorMsg: "Please input PO Qty and PO UOM.",
    required: true,
    disabled: true,
  },
  qtyReceived: {
    type: "number",
    name: "qtyReceived",
    label: "Quantity Received",
    disabled: true,
  },
  poUOM: {
    type: "select",
    name: "poUOM",
    label: "PO UOM",
    maxLength: 10,
    required: true,
  },
  baseUOM: {
    type: "text",
    name: "baseUOM",
    label: "Base UOM",
    maxLength: 10,
    disabled: true,
  },
  eta: {
    // type: "text",
    type: "date",
    name: "eta",
    label: "ETA Date",
  },
  mln: {
    type: "text",
    name: "mln",
    label: "MLN",
    maxLength: 20,
  },
  expiryDate: {
    //type: "text",
    type: "date",
    name: "expiryDate",
    label: "Expiry Date",
  },
  varianceAllowPerc: {
    type: "number",
    name: "varianceAllowPerc",
    label: "Variance Allow %",
  },
  currencyCode: {
    type: "text",
    name: "currencyCode",
    label: "Currency Code",
    maxLength: 10,
    disabled: true,
  },
  unitPrice: {
    type: "number",
    name: "unitPrice",
    label: "Unit Price",
    //prefix:"$"
  },
  specialInstruction: {
    type: "text",
    name: "specialInstruction",
    label: "Special Instruction",
    maxLength: 300,
  },
  status: {
    type: "text",
    name: "status",
    label: "Status",
    disabled: true,
  },
};

const {
  lineNo,
  status,
  extPONumber,
  extPOLineNo,
  skuCode,
  parentSKUCode,
  skuDescription,
  poQty,
  poUOM,
  packType,
  baseUOM,
  qtyOrdered,
  qtyReceived,
  eta,
  mln,
  expiryDate,
  currencyCode,
  unitPrice,
  varianceAllowPerc,
  specialInstruction,
} = formField;

// export const detailRender=[
//     [lineNo, status],
//     [extPONumber, extPOLineNo],
//     [skuCode, parentSKUCode],
//     [skuDescription],
//     [packType, poQty],
//     [baseUOM, poUOM],
//     [qtyOrdered, qtyReceived],
//     [eta, mln],
//     [expiryDate,varianceAllowPerc],
//     [currencyCode, unitPrice],
//     [specialInstruction],
//   ]
export const detailRender = [
  [lineNo, extPONumber, extPOLineNo,status],
  [skuCode, parentSKUCode, packType, baseUOM],
  [skuDescription, poUOM, poQty,varianceAllowPerc],
  [qtyOrdered, qtyReceived, currencyCode, unitPrice],
  [eta,expiryDate, mln, specialInstruction],
];

export const detailValues = getInitialValues(formField);

export const detailValidation = Yup.object().shape({
  [extPONumber.name]: Yup.string().nullable().max(20),
  [extPOLineNo.name]: Yup.string().nullable().max(20),
  [skuCode.name]: Yup.string().nullable().max(skuCode.maxLength).required(skuCode.errorMsg),

  [parentSKUCode.name]: Yup.string().nullable().max(parentSKUCode.maxLength),
  [skuDescription.name]: Yup.string().nullable().max(skuDescription.maxLength),
  [currencyCode.name]: Yup.string().nullable().max(currencyCode.maxLength),
  [specialInstruction.name]: Yup.string().nullable().max(specialInstruction.maxLength),
  [mln.name]: Yup.string().nullable().max(mln.maxLength),

  [eta.name]: Yup.string().nullable(),
  [poUOM.name]: Yup.object()
    .shape({ value: Yup.string().nullable(), label: Yup.string().nullable() })
    .nullable()
    .required(),
  [expiryDate.name]: Yup.string().nullable(),
  [poQty.name]: Yup.number()
    .min(1, "PO Qty must be greater than 1")
    .integer()
    .required("PO Qty is required"),
  [qtyOrdered.name]: Yup.number().min(1, qtyOrdered.errorMsg).integer(),
  [qtyReceived.name]: Yup.number().min(0),
  [varianceAllowPerc.name]: Yup.number().min(0),
  [unitPrice.name]: Yup.number().min(0),
});
